import { render, staticRenderFns } from "./UserAvatarCase.vue?vue&type=template&id=61016b41"
import script from "./UserAvatarCase.vue?vue&type=script&lang=js"
export * from "./UserAvatarCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports